import { setProgress } from './set-progress';

export const playbackComplete = event => {
  const $video = event.currentTarget;
  const $videoContainer = $video.closest('.js-video');
  $videoContainer.classList.add('has-ended');
  setProgress(event);
};
